import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { h2, h3, h5 } from '~/theme/utils/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};

  ${mediaQueryUp('m')} {
    padding-right: calc(100% - 514px);
  }
`

export const ReservableTabHeaderTitle = styled.h2`
  ${({ theme }) => h3({ theme })};
  font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};

  ${mediaQueryUp('m')} {
    ${({ theme }) => h2({ theme })};
    font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
  }
`

export const ReservableTabHeaderSubtitle = styled.p`
  ${({ theme }) => h5({ theme })};

  margin-bottom: 32px;
`
